// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Sorteo · landing + bases legales (theme-aware) ───────────── */
/* Radios por token, spacing en múltiplos de 4 y brass/jade vía
   variables: sin hex crudo (design system Troly §2, §6, §7). */
.sorteo {
  background: var(--bg);
  color: var(--ink);
  min-height: 100vh;
  padding: 32px 0 64px;
}

/* Reutiliza .terms__back / .terms__section* de Terms.css para el bloque legal. */

/* ── Slide de apertura ──────────────────────────────────────── */
/* La columna del arte se dimensiona sola (auto): el marco 9:16 fija
   su ancho y el copy toma el resto. */
.sorteo__slide {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 40px;
  align-items: center;
  padding: 28px;
  margin-bottom: 40px;
  border: 1px solid var(--line);
  border-radius: var(--troly-radius-lg);
  background:
    radial-gradient(120% 140% at 100% 0%, var(--teal-glow), transparent 62%),
    var(--surface);
}

.sorteo__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--teal-dark);
  margin-bottom: 12px;
}
[data-theme="dark"] .sorteo__eyebrow { color: var(--teal); }

.sorteo__title {
  font-size: clamp(26px, 4vw, 40px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
  margin-bottom: 8px;
  color: var(--ink);
}
.sorteo__prize-name {
  font-size: clamp(15px, 2vw, 18px);
  font-weight: 600;
  color: var(--teal);
  margin-bottom: 20px;
}

.sorteo__pitch {
  font-size: 14px;
  line-height: 1.75;
  color: var(--ink80);
  margin-bottom: 24px;
  max-width: 46ch;
}

.sorteo__actions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }

/* Alto mínimo 44px: objetivo táctil WCAG 2.5.5. */
.sorteo__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 12px 20px;
  border-radius: var(--troly-radius-md);
  border: none;
  background: var(--teal);
  color: var(--troly-action-ink);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: filter .18s;
}
.sorteo__cta:hover { filter: brightness(1.05); }

.sorteo__cta--ghost {
  background: transparent;
  border: 1px solid var(--line);
  color: var(--ink80);
}
.sorteo__cta--ghost:hover { border-color: var(--teal); color: var(--teal); background: var(--teal-glow); filter: none; }

.sorteo__deadline {
  margin-top: 16px;
  font-size: 12px;
  color: var(--muted);
}
.sorteo__deadline strong { color: var(--ink); font-weight: 600; }

/* ── Arte del premio · marco 9:16 ───────────────────────────── */
/* El archivo del premio es vertical pero no 9:16 exacto. En vez de
   recortarlo con \`cover\` (se comería los bordes del blíster) el marco
   pone una copia desenfocada de fondo y la foto completa encima con
   \`contain\`: relación 9:16 real, cero recorte, cero franjas muertas. */
.sorteo__art {
  margin: 0;
  width: 280px;
  max-width: 100%;
}
.sorteo__frame {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  border-radius: var(--troly-radius-lg);
  border: 1px solid var(--line);
  overflow: hidden;
  background: var(--bg);
  isolation: isolate;
}
.sorteo__frame::before {
  content: "";
  position: absolute;
  inset: -8%;
  background-image: var(--sorteo-prize-img);
  background-size: cover;
  background-position: center;
  filter: blur(24px) saturate(1.3) brightness(.65);
  z-index: 0;
}
.sorteo__frame img {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.sorteo__art figcaption {
  margin-top: 8px;
  font-size: 11px;
  color: var(--muted);
  text-align: center;
}

/* Sin archivo de premio: mismo marco 9:16, sin fondo desenfocado. */
.sorteo__frame--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-style: dashed;
  padding: 20px;
  text-align: center;
}
.sorteo__frame--empty span { font-size: 12px; color: var(--muted); line-height: 1.5; }
.sorteo__frame--empty strong { font-size: 13px; color: var(--ink); }

/* ── Cómo participar ────────────────────────────────────────── */
.sorteo__steps-title {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin-bottom: 16px;
}
.sorteo__steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 40px;
}
.sorteo__step {
  padding: 20px;
  border: 1px solid var(--line-soft);
  border-radius: var(--troly-radius-lg);
  background: var(--surface);
}
.sorteo__step-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--troly-radius-md);
  background: var(--teal-glow);
  color: var(--teal);
  margin-bottom: 12px;
}
.sorteo__step h3 { font-size: 14px; font-weight: 700; letter-spacing: -0.01em; color: var(--ink); margin-bottom: 8px; }
.sorteo__step p  { font-size: 13px; color: var(--ink80); line-height: 1.6; }
.sorteo__step a  { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }

/* ── Lista de números ───────────────────────────────────────── */
.sorteo__numbers {
  padding: 24px;
  border: 1px solid var(--line-soft);
  border-radius: var(--troly-radius-lg);
  background: var(--surface);
  margin-bottom: 8px;
}
.sorteo__numbers h2 { font-size: 17px; font-weight: 700; letter-spacing: -0.01em; color: var(--ink); margin-bottom: 8px; }
.sorteo__numbers p  { font-size: 13px; color: var(--ink80); line-height: 1.7; }

/* ── Nota regulatoria · brass como acento ───────────────────── */
.sorteo__note {
  margin-top: 8px;
  padding: 16px;
  border-radius: var(--troly-radius-md);
  background: color-mix(in srgb, var(--troly-accent) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--troly-accent) 28%, transparent);
}
.sorteo__note h3 { font-size: 13px; font-weight: 700; color: var(--ink); margin-bottom: 8px; }
.sorteo__note p  { font-size: 13px; color: var(--ink80); line-height: 1.7; }

/* Móvil primero en intención: por debajo de md el slide es una columna
   y el arte 9:16 se centra con un ancho que no empuje el copy fuera. */
@media (max-width: 767px) {
  /* .container global fija 40px de padding a cualquier ancho: a 360px deja
     el copy en 240px. Lo acotamos SOLO en esta página al xs del sistema. */
  .sorteo .container { padding-inline: 16px; }
  .sorteo__slide { grid-template-columns: 1fr; gap: 24px; padding: 20px; }
  .sorteo__art { width: 240px; margin-inline: auto; }
  .sorteo__steps { grid-template-columns: 1fr; }
}

@media (prefers-reduced-motion: reduce) {
  .sorteo__cta { transition: none; }
}

/* ── Lista pública de números ────────────────────────────────── */
.sorteo__list-msg {
  margin-top: 16px;
  font-size: 13px;
  color: var(--muted);
}
.sorteo__list-count {
  margin-top: 16px;
  font-size: 12px;
  color: var(--muted);
  letter-spacing: .04em;
  text-transform: uppercase;
}
.sorteo__list {
  list-style: none;
  margin: 12px 0 16px;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 8px;
  /* La lista crece sin techo: la acotamos y dejamos que scrollee dentro de
     su caja en lugar de empujar las bases legales fuera de la pantalla. */
  max-height: 420px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.sorteo__list-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid var(--line-soft);
  border-radius: var(--troly-radius-md);
  background: var(--bg);
}
.sorteo__list-num {
  flex: 0 0 auto;
  font-family: var(--troly-font-mono, monospace);
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--teal);
}
.sorteo__list-name {
  min-width: 0;
  font-size: 13px;
  color: var(--ink80);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
a.sorteo__list-name:hover { color: var(--teal); }
.sorteo__list-closed {
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: var(--troly-radius-md);
  background: color-mix(in srgb, var(--troly-accent) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--troly-accent) 28%, transparent);
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sorteo.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;+DAC+D;AAC/D;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,iFAAiF;;AAEjF,kEAAkE;AAClE;sCACsC;AACtC;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC;;kBAEgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,uCAAuC,kBAAkB,EAAE;;AAE3D;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAElF,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;AACA,qBAAqB,wBAAwB,EAAE;;AAE/C;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA,4BAA4B,yBAAyB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,YAAY,EAAE;;AAEvH;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,2BAA2B,iBAAiB,EAAE,gBAAgB,EAAE;;AAEhE,kEAAkE;AAClE;;;uEAGuE;AACvE;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,gDAAgD;EAChD,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;AACA,6BAA6B,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACrF,+BAA+B,eAAe,EAAE,iBAAiB,EAAE;;AAEnE,kEAAkE;AAClE;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACtH,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC3E,mBAAmB,kBAAkB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;;AAE/F,kEAAkE;AAClE;EACE,aAAa;EACb,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;AACpB;AACA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACzH,sBAAsB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE9E,kEAAkE;AAClE;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,oEAAoE;EACpE,0EAA0E;AAC5E;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7F,mBAAmB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE3E;uEACuE;AACvE;EACE;2EACyE;EACzE,qBAAqB,oBAAoB,EAAE;EAC3C,iBAAiB,0BAA0B,EAAE,SAAS,EAAE,aAAa,EAAE;EACvE,eAAe,YAAY,EAAE,mBAAmB,EAAE;EAClD,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA;EACE,eAAe,gBAAgB,EAAE;AACnC;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR;0EACwE;EACxE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,4BAA4B,kBAAkB,EAAE;AAChD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,oEAAoE;EACpE,0EAA0E;EAC1E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* ── Sorteo · landing + bases legales (theme-aware) ───────────── */\n/* Radios por token, spacing en múltiplos de 4 y brass/jade vía\n   variables: sin hex crudo (design system Troly §2, §6, §7). */\n.sorteo {\n  background: var(--bg);\n  color: var(--ink);\n  min-height: 100vh;\n  padding: 32px 0 64px;\n}\n\n/* Reutiliza .terms__back / .terms__section* de Terms.css para el bloque legal. */\n\n/* ── Slide de apertura ──────────────────────────────────────── */\n/* La columna del arte se dimensiona sola (auto): el marco 9:16 fija\n   su ancho y el copy toma el resto. */\n.sorteo__slide {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 40px;\n  align-items: center;\n  padding: 28px;\n  margin-bottom: 40px;\n  border: 1px solid var(--line);\n  border-radius: var(--troly-radius-lg);\n  background:\n    radial-gradient(120% 140% at 100% 0%, var(--teal-glow), transparent 62%),\n    var(--surface);\n}\n\n.sorteo__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .16em;\n  text-transform: uppercase;\n  color: var(--teal-dark);\n  margin-bottom: 12px;\n}\n[data-theme=\"dark\"] .sorteo__eyebrow { color: var(--teal); }\n\n.sorteo__title {\n  font-size: clamp(26px, 4vw, 40px);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  margin-bottom: 8px;\n  color: var(--ink);\n}\n.sorteo__prize-name {\n  font-size: clamp(15px, 2vw, 18px);\n  font-weight: 600;\n  color: var(--teal);\n  margin-bottom: 20px;\n}\n\n.sorteo__pitch {\n  font-size: 14px;\n  line-height: 1.75;\n  color: var(--ink80);\n  margin-bottom: 24px;\n  max-width: 46ch;\n}\n\n.sorteo__actions { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }\n\n/* Alto mínimo 44px: objetivo táctil WCAG 2.5.5. */\n.sorteo__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 12px 20px;\n  border-radius: var(--troly-radius-md);\n  border: none;\n  background: var(--teal);\n  color: var(--troly-action-ink);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n  transition: filter .18s;\n}\n.sorteo__cta:hover { filter: brightness(1.05); }\n\n.sorteo__cta--ghost {\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--ink80);\n}\n.sorteo__cta--ghost:hover { border-color: var(--teal); color: var(--teal); background: var(--teal-glow); filter: none; }\n\n.sorteo__deadline {\n  margin-top: 16px;\n  font-size: 12px;\n  color: var(--muted);\n}\n.sorteo__deadline strong { color: var(--ink); font-weight: 600; }\n\n/* ── Arte del premio · marco 9:16 ───────────────────────────── */\n/* El archivo del premio es vertical pero no 9:16 exacto. En vez de\n   recortarlo con `cover` (se comería los bordes del blíster) el marco\n   pone una copia desenfocada de fondo y la foto completa encima con\n   `contain`: relación 9:16 real, cero recorte, cero franjas muertas. */\n.sorteo__art {\n  margin: 0;\n  width: 280px;\n  max-width: 100%;\n}\n.sorteo__frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 9 / 16;\n  border-radius: var(--troly-radius-lg);\n  border: 1px solid var(--line);\n  overflow: hidden;\n  background: var(--bg);\n  isolation: isolate;\n}\n.sorteo__frame::before {\n  content: \"\";\n  position: absolute;\n  inset: -8%;\n  background-image: var(--sorteo-prize-img);\n  background-size: cover;\n  background-position: center;\n  filter: blur(24px) saturate(1.3) brightness(.65);\n  z-index: 0;\n}\n.sorteo__frame img {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.sorteo__art figcaption {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--muted);\n  text-align: center;\n}\n\n/* Sin archivo de premio: mismo marco 9:16, sin fondo desenfocado. */\n.sorteo__frame--empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-style: dashed;\n  padding: 20px;\n  text-align: center;\n}\n.sorteo__frame--empty span { font-size: 12px; color: var(--muted); line-height: 1.5; }\n.sorteo__frame--empty strong { font-size: 13px; color: var(--ink); }\n\n/* ── Cómo participar ────────────────────────────────────────── */\n.sorteo__steps-title {\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin-bottom: 16px;\n}\n.sorteo__steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 40px;\n}\n.sorteo__step {\n  padding: 20px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--troly-radius-lg);\n  background: var(--surface);\n}\n.sorteo__step-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--troly-radius-md);\n  background: var(--teal-glow);\n  color: var(--teal);\n  margin-bottom: 12px;\n}\n.sorteo__step h3 { font-size: 14px; font-weight: 700; letter-spacing: -0.01em; color: var(--ink); margin-bottom: 8px; }\n.sorteo__step p  { font-size: 13px; color: var(--ink80); line-height: 1.6; }\n.sorteo__step a  { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }\n\n/* ── Lista de números ───────────────────────────────────────── */\n.sorteo__numbers {\n  padding: 24px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--troly-radius-lg);\n  background: var(--surface);\n  margin-bottom: 8px;\n}\n.sorteo__numbers h2 { font-size: 17px; font-weight: 700; letter-spacing: -0.01em; color: var(--ink); margin-bottom: 8px; }\n.sorteo__numbers p  { font-size: 13px; color: var(--ink80); line-height: 1.7; }\n\n/* ── Nota regulatoria · brass como acento ───────────────────── */\n.sorteo__note {\n  margin-top: 8px;\n  padding: 16px;\n  border-radius: var(--troly-radius-md);\n  background: color-mix(in srgb, var(--troly-accent) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--troly-accent) 28%, transparent);\n}\n.sorteo__note h3 { font-size: 13px; font-weight: 700; color: var(--ink); margin-bottom: 8px; }\n.sorteo__note p  { font-size: 13px; color: var(--ink80); line-height: 1.7; }\n\n/* Móvil primero en intención: por debajo de md el slide es una columna\n   y el arte 9:16 se centra con un ancho que no empuje el copy fuera. */\n@media (max-width: 767px) {\n  /* .container global fija 40px de padding a cualquier ancho: a 360px deja\n     el copy en 240px. Lo acotamos SOLO en esta página al xs del sistema. */\n  .sorteo .container { padding-inline: 16px; }\n  .sorteo__slide { grid-template-columns: 1fr; gap: 24px; padding: 20px; }\n  .sorteo__art { width: 240px; margin-inline: auto; }\n  .sorteo__steps { grid-template-columns: 1fr; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sorteo__cta { transition: none; }\n}\n\n/* ── Lista pública de números ────────────────────────────────── */\n.sorteo__list-msg {\n  margin-top: 16px;\n  font-size: 13px;\n  color: var(--muted);\n}\n.sorteo__list-count {\n  margin-top: 16px;\n  font-size: 12px;\n  color: var(--muted);\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n.sorteo__list {\n  list-style: none;\n  margin: 12px 0 16px;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 8px;\n  /* La lista crece sin techo: la acotamos y dejamos que scrollee dentro de\n     su caja en lugar de empujar las bases legales fuera de la pantalla. */\n  max-height: 420px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n.sorteo__list-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 8px 12px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--troly-radius-md);\n  background: var(--bg);\n}\n.sorteo__list-num {\n  flex: 0 0 auto;\n  font-family: var(--troly-font-mono, monospace);\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--teal);\n}\n.sorteo__list-name {\n  min-width: 0;\n  font-size: 13px;\n  color: var(--ink80);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\na.sorteo__list-name:hover { color: var(--teal); }\n.sorteo__list-closed {\n  margin-top: 16px;\n  padding: 12px 16px;\n  border-radius: var(--troly-radius-md);\n  background: color-mix(in srgb, var(--troly-accent) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--troly-accent) 28%, transparent);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
